import React from 'react';
import cx from 'classnames';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

import type { MegaMenuNavItem, NavItemClickTrackHandler } from 'components/navV2/NavData/types';
import SubMenuColumn from 'components/navV2/navPrimarySubMenu/SubMenuColumn';
import NavMarketingModuleAsBgImage from 'components/navV2/navPrimarySubMenu/NavMarketingModuleAsBgImage';
import TextUtil from 'util/TextUtil';
import { NAV_SECTIONS } from 'util/trackNavigationClickedHelpers';
import { primaryNavItemToBusinessUnitMap } from 'components/navV2/navPrimarySubMenu/helpers/mapPrimaryNavItemToBusinessUnit';
import { trackNavigationClicked } from 'util/trackingHelper';

import css from '../subMenu.module.less';
import styles from './NavPrimaryAdviceSubMenu.module.less';

const NavPrimaryAdviceSubMenu = ({
  activeNavType,
  data: { title, children, id },
}: {
  activeNavType: PrimaryNavIdentifier.ADVICE;
  data: MegaMenuNavItem;
}): JSX.Element => {
  const handleNavItemClick: NavItemClickTrackHandler = ({
    linkText,
    rowPosition,
    columnPosition,
  }) => {
    trackNavigationClicked({
      menu_item: TextUtil.toAllUpperCase(linkText),
      section: NAV_SECTIONS.primarySubNav,
      node_level_1: TextUtil.toAllUpperCase(title),
      row_position: rowPosition,
      column_position: columnPosition,
    });
  };

  const businessUnit = primaryNavItemToBusinessUnitMap[id];

  return (
    <>
      <div className={cx(css.columnContainer, styles.adviceColumnContainer)}>
        {children.map((child, i) => {
          const columnPosition = i + 1; // col-position is 1-indexed.
          return (
            <SubMenuColumn
              headline={child.headline}
              links={child.children}
              borderLeft={child.borderLeft}
              twoColumns={child.twoColumns}
              key={i}
              columnPosition={columnPosition}
              onNavItemClick={handleNavItemClick}
            />
          );
        })}
      </div>
      <NavMarketingModuleAsBgImage
        activeNavType={activeNavType}
        businessUnit={businessUnit}
        imageSize="354x302"
        className={styles.module}
      />
    </>
  );
};

export default NavPrimaryAdviceSubMenu;
